import ContinueWithWixButton from './ContinueWithWixButton'

export default ContinueWithWixButton
